import axios from "axios";
import queryString from "query-string";

const SearchServices = {
  SuscriptionUSers: async (data) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/eira/subscription-user?${queryString.stringify(data)}`
    );
    return response;
  },
  SearchPatient: async (values, data) => {
    let args = { ...data };
    if (values.first_name) {
      args["name"] = values.first_name;
    }
    if (values.last_name) {
      args["name"] = values.first_name
        ? values.first_name + " " + values.last_name
        : values.last_name;
    }
    if (values.email) {
      args["email"] = values.email;
    }
    if (values.document) {
      args["national_identity"] = values.document;
    }
    if (values.professional_id) {
      args["professional_id"] = values.professional_id;
    }

    const response = await axios.post(
      process.env.REACT_APP_API_URL + `/service/search-patient`,
      args
    );
    return response;
  },
  Professionals: async () => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + `/eira/profeessional`
    );
    return response;
  },
};
export default SearchServices;
